import React from 'react'
import { Link } from 'react-router-dom'

export default function Notification() {
  return (
    <div className='notificationPage'>
      <div className="ntHeader">
         Notification
         <Link className="notiBack" to={"/"}>
         <img src="/assets/images/left-arrow-next-svgrepo-com.svg" alt="" width={15} />
 
         </Link>
      </div>
      <div className="ntList">
        {
            [1,2,3,4,4,5,].map((message)=>(
                <div>
                    <div className="flex align-items-center ntItemHeader">
                        <img src="/assets/images/notice-8d53455c.png" alt="" width={25} />
                        <p>Important Notice of Withdrawal Delay</p>
                    </div>
                    <div className="ntDescription">
                    If you have not received your withdrawal within 3 days, please contact our self-service center with your bank statement (PDF/VIDEO) and PDF password (if it applies) for us to do the verification and we will assist you in resolving the issue immediately. Thank you for your patience!
                    </div>
                    <div className="ntDate">
                        2024-12-15 19:03:04
                    </div>
                </div>
            ))
        }
      </div>
    </div>
  )
}
